import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { SideBar } from '../Common/SideBar';
import Request from '../../Models/Request';
import { Footer, Header } from '../Common';
// import { connect } from 'react-redux';
// import { buyerLogin } from '../../../Action/login';

class RequestDetailsBuyerSeller extends React.Component {
    constructor(props) {
        super(props);
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        this.state = {
            minHeight: "475px",
            RequestList: [],
            requestdetails: [],
            responselist: [],
            request: [],
            requestAll: [],
            existing: [],
            accepted: '',
            sellerResponse: '',
            count: '',
            id: logged_user.id,
            content: ''
        };
        this.getResponseAll();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    getResponseAll() {
        Request.getRequestResponse(this.props.location.state.id).then(res => {
            console.log(res.data)
            this.setState({ requestdetails: res.data.request })
            this.setState({ sellerResponse: res.data.request.accepted_seller_id })
            this.setState({ responselist: res.data.response })
            this.setState({ accepted: res.data.accepted_id })
            this.setState({ content: res.data.request.content })
            console.log(this.state.requestdetails)
            this.getResponseDetails();
        })

    }
    getResponseDetails() {
        Request.getRequestDetail(this.props.location.state.id, this.state.sellerResponse).then(res => {
            if (res.data.payload != null) {
                this.setState({ request: res.data.payload })
                this.setState({ requestAll: res.data.requestall })
                this.setState({ count: res.data.count })
                this.setState({ existing: res.data.existing_response })
            }
        })
    }
    updateField(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    Accept(a, b) {
        // document.getElementById("res_entry").disabled = true;
        let data = {
            'request_id': a,
            'seller_id': b,
            'buyer_id': this.state.requestdetails.buyer_id
        }
        Request.acceptResponse(data).then(res => {
            if (res.data.status === 200) {
                alert(this.props.t('1'))
                this.setState({ accepted: res.data.id })
                this.props.history.push('/seller-buyer-estimate');
                // window.location.reload();
            }
            // else if (res.data.status === 10060) {
            //     alert('You have already accepted another proposal!');
            //     this.setState({ accepted: 0 })
            // }
            // else {
            //     alert('{this.props.t('0')} {this.props.t('2')}');
            //     this.setState({ accepted: 0 })
            //     document.getElementById("res_entry").disabled = false;
            // }
        })
            .catch(
                console.log('asd')
            )
    }

    existingRequest() {
        if (this.state.existing.length > 0) {
            return (
                <div className="card" style={{ width: "100%" }}>
                    {this.state.existing.map(group =>
                        <div className="card-body" style={{ width: "100%", backgroundColor: '#f4f2f0' }}>
                            <div className="row">
                                {/* <div className="col-md-2"></div> */}
                                <div className="col-md-12 mb-1"> {this.props.t('5')}: &nbsp;
                                    {/* {group.content} */}
                                    {group.content.split('\n').map(function (item, key) {
                                        return (
                                            <span key={key}>
                                                {item}
                                                <br />
                                            </span>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className="row mb-1">
                                <div className="col-md-12">
                                    {this.props.t('11')}: {group.estimated_price}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    {this.props.t('6')}: {group.estimated_deadline.substring(0, 11)}
                                </div>
                            </div>
                            <br />
                        </div>
                    )}
                </div>
            )
        }
    }

    productsTitle() {
        if (this.state.requestdetails.product_id) {
            if (this.state.requestdetails.budget_range !== null) {
                return (
                    <Link to={{
                        pathname: `/categories-details/${this.state.requestdetails.product_id}`,
                        state: { id: this.state.requestdetails.product_id }
                    }} className="col-md-12">
                        {this.state.requestdetails.pro_title}
                    </Link>
                )
            } else {
                return (
                    <div className=""></div>
                )
            }
        } else {
            return (
                <div className=""></div>
            )
        }
    }

    description() {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (this.state.requestdetails.budget_range === null) {
            return (
                <div className="card " style={{ border: '0px solid', backgroundColor: '#f4f2f0' }}>
                    {renderHTML(this.state.requestdetails.long_desc)}
                </div>
            )
        } else {
            return (
                <div className=" card" style={{ border: '0px solid', backgroundColor: '#f4f2f0' }}>
                    {/* {this.state.requestdetails.content} */}
                    {this.state.content.split('\n').map(function (item, key) {
                        return (
                            <span key={key}>
                                {item}
                                <br />
                            </span>
                        )
                    })}
                </div>
            )
        }
    }

    title() {
        if (this.state.requestdetails.budget_range === null) {
            return (
                <div className="">
                    <Link to={{
                        pathname: `/categories-details/${this.state.requestdetails.product_id}`,
                        state: { id: this.state.requestdetails.product_id }
                    }} className="">
                        {this.state.requestdetails.pro_title}
                    </Link>
                </div>
            )
        } else {
            return (
                <div className="">
                    {this.state.requestdetails.title}
                </div>
            )
        }
    }

    pageStatus() {
        if (this.state.requestdetails.current_status === 'TRADING') {
            return (
                <div >
                    <div className="card" style={{ width: "100%", backgroundColor: '#f4f2f0' }}>
                        <div className=" row card-body" >
                            <div className="col-md-12 ">
                                <Link to={{ pathname: `/my-profile/users/${this.state.requestdetails.accepted_seller_id}`, state: { id: this.state.requestdetails.accepted_seller_id } }} className="row">
                                    <div className="col-md-12"><b>{this.state.requestdetails.first_name}</b></div>
                                </Link>
                                <div className="small-hidden">
                                    <br />
                                </div>
                                <div className="row">
                                    {this.productsTitle()}
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-md-3">{this.props.t('20')}</div>
                                    <div className="col-md-1 small-hidden">:</div>
                                    <div className="col-md-8"><b>{this.state.requestdetails.created_at.substr(0, 11)}</b></div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-md-3">{this.props.t('12')}</div>
                                    <div className="col-md-1 small-hidden">:</div>
                                    <div className="col-md-8"><b>{this.state.requestdetails.proposed_budget} {this.props.t('26')}</b></div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-md-3">{this.props.t('13')}</div>
                                    <div className="col-md-1 small-hidden">:</div>
                                    <div className="col-md-8"><b>{this.title()}</b></div>
                                </div>
                            </div>
                            <div className="card-body col-md-12" > {this.description()}</div>
                        </div>
                    </div>
                    &nbsp;
                    {this.existingRequest()}
                </div>
            )
        } else if (this.state.requestdetails.current_status === 'COMPLETE') {
            return (
                <div >
                    <div className="card" style={{ width: "100%", backgroundColor: '#f4f2f0' }}>
                        <div className=" row card-body" >
                            <div className="col-md-12 ">
                                <Link to={{ pathname: `/my-profile/users/${this.state.requestdetails.accepted_seller_id}`, state: { id: this.state.requestdetails.accepted_seller_id } }} className="row">
                                    <div className="col-md-12"><b>{this.state.requestdetails.first_name}</b></div>
                                </Link>
                                <div className="small-hidden">
                                    <br />
                                </div>
                                <div className="row">
                                    {this.productsTitle()}
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-md-3">{this.props.t('20')}</div>
                                    <div className="col-md-1 small-hidden">:</div>
                                    <div className="col-md-8"><b>{this.state.requestdetails.created_at.substr(0, 11)}</b></div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-md-3">{this.props.t('12')}</div>
                                    <div className="col-md-1 small-hidden">:</div>
                                    <div className="col-md-8"><b>{this.state.requestdetails.proposed_budget} {this.props.t('26')}</b></div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-md-3">{this.props.t('13')}</div>
                                    <div className="col-md-1 small-hidden">:</div>
                                    <div className="col-md-8"><b>{this.title()}</b></div>
                                </div>
                            </div>
                            <div className="card-body col-md-12"> <span>{this.description()}</span></div>
                        </div>
                    </div>
                    &nbsp;
                    {this.existingRequest()}
                </div>
            )
        } else if (this.state.requestdetails.current_status === 'CANCEL') {
            return (
                <div >
                    <div className="card" style={{ width: "100%", backgroundColor: '#f4f2f0' }}>
                        <div className=" row card-body" >
                            <div className="col-md-12 ">
                                <Link to={{ pathname: `/my-profile/users/${this.state.requestdetails.accepted_seller_id}`, state: { id: this.state.requestdetails.accepted_seller_id } }} className="row">
                                    <div className="col-md-12"><b>{this.state.requestdetails.first_name}</b></div>
                                </Link>
                                <div className="row">
                                    {this.productsTitle()}
                                </div>
                                <div className="small-hidden">
                                    <br />
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-md-3">{this.props.t('20')}</div>
                                    <div className="col-md-1 small-hidden">:</div>
                                    <div className="col-md-8"><b>{this.state.requestdetails.created_at.substr(0, 11)}</b></div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-md-3">{this.props.t('12')}</div>
                                    <div className="col-md-1 small-hidden">:</div>
                                    <div className="col-md-8"><b>{this.state.requestdetails.proposed_budget} {this.props.t('26')}</b></div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-md-3">{this.props.t('13')}</div>
                                    <div className="col-md-1 small-hidden">:</div>
                                    <div className="col-md-8"><b>{this.title()}</b></div>
                                </div>
                            </div>
                            <div className="card-body col-md-12"> <span>{this.description()}</span></div>
                        </div>
                    </div>
                    &nbsp;
                    {this.existingRequest()}
                </div>
            )
        } else if (this.state.requestdetails.current_status === 'UNDERESTIMATION') {
            return (
                <div >
                    <div className="card" style={{ width: "100%", backgroundColor: '#f4f2f0' }}>
                        <div className=" card-body" style={{ border: '0px solid' }} >
                            <div className="col-md-12 ">
                                <div className="row">
                                    <div className="col-md-3">{this.props.t('23')}</div>
                                    <div className="col-md-1 small-hidden">:</div>
                                    <div className="col-md-8"><b>{this.state.requestdetails.created_at.substr(0, 11)}</b></div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-md-3">{this.props.t('3')}</div>
                                    <div className="col-md-1 small-hidden">:</div>
                                    <div className="col-md-8"><b>{this.state.requestdetails.application_date}</b></div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-md-3">{this.props.t('7')}</div>
                                    <div className="col-md-1 small-hidden">:</div>
                                    <div className="col-md-8"><b>{this.state.requestdetails.budget_range} {this.props.t('26')}</b></div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-md-3">{this.props.t('13')}</div>
                                    <div className="col-md-1 small-hidden">:</div>
                                    <div className="col-md-8"><b>{this.state.requestdetails.title}</b></div>
                                </div>
                            </div>
                            <div className="card-body col-md-12">
                                <span >
                                    {this.state.content.split('\n').map(function (item, key) {
                                        return (
                                            <span key={key}>
                                                {item}
                                                <br />
                                            </span>
                                        )
                                    })}
                                </span>
                            </div>
                        </div>
                    </div>
                    &nbsp;
                     {(() => {
                        if (this.state.responselist.length === 0) {
                            return (
                                <div></div>
                            )
                        } else {
                            return (
                                <div className="card">
                                    {this.state.responselist.map(group =>
                                        <div className=" card-body" style={{ width: "100%", backgroundColor: '#f4f2f0' }} >
                                            <div className=" row" >
                                                <div className="col-md-10">
                                                    <Link to={{ pathname: `/my-profile/users/${group.seller_id}`, state: { id: group.seller_id } }} style={{ textAlign: "left" }}>
                                                        {group.first_name}
                                                    </Link>
                                                    <div style={{ textAlign: "left" }} className="mb-1">
                                                        <span >{this.props.t('11')}: </span>{parseInt(group.estimated_price)}
                                                    </div>
                                                    <div style={{ textAlign: "left" }} className="mb-1">
                                                        <span >{this.props.t('6')}: </span>
                                                        {(() => {
                                                            if (group.estimated_deadline.length !== 0) {
                                                                return (
                                                                    <span>{group.estimated_deadline.substring(0, 11)}</span>
                                                                )
                                                            } else {
                                                                return (
                                                                    <span></span>
                                                                )
                                                            }
                                                        })()}
                                                    </div>
                                                    <div style={{ textAlign: "left" }} className="mb-1"> {this.props.t('5')}: &nbsp;
                                                        {group.content.split('\n').map(function (item, key) {
                                                        return (
                                                            <span key={key}>
                                                                {item}
                                                                <br />
                                                            </span>
                                                        )
                                                    })}
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    {(() => {
                                                        if (this.state.accepted === group.id && this.state.requestdetails.acceptance_status != 'INITIATED') {
                                                            return (
                                                                <button style={{ padding: "12%", borderRdius: "8px", backgroundColor: "white", color: "red" }}>{this.props.t('4')}</button>
                                                            )
                                                        } else {
                                                            return (
                                                                <button id="res_entry" onClick={() => this.Accept(group.request_id, group.seller_id)} style={{ padding: "", width: '100px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }}>{this.props.t('10')}</button>
                                                            )
                                                        }
                                                    })()}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )
                        }
                    })()}
                </div>
            )
        }
    }


    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile view
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                <SideBar />
                            </div> */}
                            <div className="col-md-8">
                                <div className="mt-5 input_name big_font text-left" style={{ width: "100%", fontSize: '20px' }}>
                                    {this.props.t('24')}
                                </div>
                                <div className="pages_contents">
                                    {this.pageStatus()}
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            );
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font text-left" style={{ width: "100%" }}>
                                            {this.props.t('24')}
                                    </div>
                                        <div>
                                            {this.pageStatus()}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            );
        }
    }
}

export { RequestDetailsBuyerSeller };


 RequestDetailsBuyerSeller = withTranslation('src_Components_Request_RequestDetailsBuyerSeller')(RequestDetailsBuyerSeller);